import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { API_BASE_URL } from '../../utils/apiClient';
import './Encrusted.css';

const Encrusted = ({ game, selectedRomVersion }) => {
  const iframeRef = useRef(null);
  
  // Use the ROM path already selected in the game object
  const romToUse = game.rom;

  // Ensure the story param is a full URL
  let romUrl;
  if (romToUse.startsWith('http://') || romToUse.startsWith('https://')) {
    romUrl = romToUse;
  } else if (romToUse.startsWith('/')) {
    romUrl = `${API_BASE_URL}${romToUse}`;
  } else {
    romUrl = romToUse; // fallback, but ideally shouldn't happen
  }
  
  useEffect(() => {
    // Add a listener to handle any iframe loading issues
    const handleIframeLoad = () => {
      console.log('Encrusted iframe loaded');
      
      // Force iframe to be visible and sized properly
      if (iframeRef.current) {
        iframeRef.current.style.display = 'block';
        iframeRef.current.style.width = '100%';
        iframeRef.current.style.height = '100%';
      }
    };
    
    // Add the event listener if the ref is available
    const iframe = iframeRef.current;
    if (iframe) {
      iframe.addEventListener('load', handleIframeLoad);
      
      // Force iframe to be visible initially
      iframe.style.display = 'block';
      iframe.style.width = '100%';
      iframe.style.height = '100%';
    }
    
    // Clean up
    return () => {
      if (iframe) {
        iframe.removeEventListener('load', handleIframeLoad);
      }
    };
  }, []);
  
  // Format the iframe source URL according to the specified format
  // "https://rgm.games/encrusted/run?story=(rom url)"
  const storyUrl = encodeURIComponent(romUrl);
  const iframeSrc = `https://rgm.games/encrusted/run?story=${storyUrl}`;
  
  console.log('Loading Encrusted with URL:', iframeSrc);
  
  return (
    <div className="encrusted-container">
      <iframe
        ref={iframeRef}
        src={iframeSrc}
        title={game.titleeng || game.titlechn}
        className="emulator-frame encrusted-frame"
        allow="autoplay"
        allowFullScreen
      />
    </div>
  );
};

Encrusted.propTypes = {
  game: PropTypes.object.isRequired,
  selectedRomVersion: PropTypes.string.isRequired
};

export default Encrusted; 